<template>
    <el-drawer
        title="选择歌曲(最多选择10首)"
        :visible.sync="drawerShow"
        :wrapperClosable="false"
        :destroy-on-close="true"
        size="auto"
        @close="close"
    >
        <div class="drawer-content" >
            <el-checkbox-group v-model="checkedIds" :max="10">
                <div v-for="(item,index) in musicList" :key="index">
                    <h2 class="userName">{{item.userName}}</h2>
                    <el-row :gutter="40">
                        <el-col v-for="v in item.musics" :key="v.TSID" :xs="24" :sm="12" :md="8">
                            <el-checkbox :label="v.TSID" >{{v.title}}</el-checkbox>
                        </el-col>
                    </el-row>
                </div>
            </el-checkbox-group>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">取 消</el-button>
            <el-button type="primary" @click="submit()" :loading="btnLoading"
                >确 定</el-button
            >
        </div>
    </el-drawer>
</template>

<script>
export default {
    props:{
        activityId:{
            type:[Number,String],
            default: null
        },
        musicIds:{
            type: Array,
            default: () => []
        },
        
    },
    data(){
        return{
            drawerShow: false,
            dataLoading: false,
            btnLoading:false,
            musicList:null,
            checkedIds:[],
			checkedList:[]
        }
    },
    created(){
        this.getData();
		
    },
    methods:{
        close() {
            this.drawerShow = false;
        },
        show(){
            this.checkedList = this.musicIds;
            this.drawerShow = true;
			
			var str = ""
			this.checkedList.forEach(function(e){
				str += e.TSID + ','
			})			
			str = str.substring(0,str.length - 1)
			this.checkedIds = str.split(",")
        },
        getData(){
            this.dataLoading = true;
            this.$request({
                url: "/music/ac_list",
                params: { activityId: this.activityId },
                method: "post",
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1) {
                        this.musicList = result;
						// this.checked()
                    } else {
                        this.$message.error(msg || "操作失败,请重试");
                    }
                })
                .catch(() => {
                    this.$message.error("操作失败,请重试");
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        },
		
        submit(){
            //this.$emit('update:musicIds',[...this.checkedIds]);
            const _arry = [];
            this.musicList.forEach(item => {
                item.musics.forEach( a => {
                    this.checkedIds.forEach( v => {
                        if(a.TSID === v){
                            _arry.push({                               
                                title: a.title,
                                userName: item.userName,
								duration:a.duration,
								releaseDate:a.releaseDate ? a.releaseDate : '',
								TSID:a.TSID,
								userId:item.userId
                            });
							
                        }
						
                    })
                })
            })
			
            this.$emit('update:musicIds',[..._arry]);
			
			
            this.close();
        }
    }
}
</script>

<style lang="scss" scoped>
.userName{
    font-size: 16px;
}
</style>